<!-- <p>dashboard works!</p> -->

<!-- <router-outlet></router-outlet> -->



<div class="row">
   <div class="col-xl-3 col-sm-6 col-12 d-flex">
      <div class="card bg-one w-100">
         <div class="card-body">
            <div class="db-widgets d-flex justify-content-between align-items-center">
               <div class="db-icon">
                  <i class="fas fa-user-graduate"></i>
               </div>
               <div class="db-info">
                  <h3>786</h3>
                  <h6><a routerLink="/students">
                   Student</a></h6>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div class="col-xl-3 col-sm-6 col-12 d-flex">
      <div class="card bg-two w-100">
         <div class="card-body">
            <div class="db-widgets d-flex justify-content-between align-items-center">
               <div class="db-icon">
                  <i class="fas fa-chalkboard-teacher"></i>
               </div>
               <div class="db-info">
                  <h3>69</h3>
                  <h6><a routerLink="/teachers">Teacher</a></h6>
               </div>
            </div>
         </div>
      </div>
   </div>
  
   <!-- <div class="col-xl-3 col-sm-6 col-12 d-flex">
      <div class="card bg-four w-100">
         <div class="card-body">
            <div class="db-widgets d-flex justify-content-between align-items-center">
               <div class="db-icon">
                  <i class="fas fa-file-invoice-dollar"></i>
               </div>
               <div class="db-info">
                  <h3>$505</h3>
                  <h6>Revenue</h6>
               </div>
            </div>
         </div>
      </div>
   </div> -->
</div>